export default {
  ENTER_NAME: `输入姓名`,
  JOIN: `立即加入`,
  CHOOSE_A_PICTURE: `选择头像`,
  SUPPORTED_BY: `由网易云信提供技术支持`,
  MEETING_EXPIRED: `会议链接已失效`,
  GRID_VIEW: `宫格视图`,
  PRESENTER_VIEW: `演讲者视图`,
  EXPAND: `展开参会人面板`,
  COLLAPSE: `收起参会人面板`,
  NO_DEVICE: `未检测到可用设备，请重试或接入其他设备`,
  CONFIRM_LEAVE: `确定要离开会议吗？`,
  BROWSER: `浏览器`,
  LOOKING_AT_THE_SCREEN: `正在查看{name}的屏幕`,
  DEVICE_NAME: `设备名称`,
  MUTE_ON_ENTRY: `当前主持人设置默认静音`,
  NOT_ALLOWED_TURNED_ON_DEVICE: `当前开麦人数较多，主持人已禁止开启设备`,
  NEW_HOST: `{name}成为主持人`,
  OFFLINE: `网络连接异常，请检查网络设置`,
  CONNECTION_IS_UNSTABLE: `当前网络状态不佳`,
  UNSTABLE_CONNECTION: `连接不稳定`,
  TRYING_TO_RECONNECT: `正在尝试重新连接...`,
  CONNECTION_FAILED: `连接失败`,
  NETWORK_CONNECTION_FAILED: `网络连接失败，通话中断`,
  THE_HOST_ASKED_TO_TURN_ON_YOUR_CAMERA: `主持人请求打开您的摄像头`,
  REJECT: `拒绝`,
  OPEN: `打开`,
  EXPERIENCE: `视频会议体验如何？`,
  OTHER_FEEDBACK: `还有其它问题？`,
  THANKS: `感谢使用网页版 POPO 会议`,
  CANCEL: `取消`,
  LEAVE: `离开`,
  SUBMIT: `提交`,
  DURATION: `会议时长`,
  GREAT: `体验不错`,
  ISSUES: `有待改进`,
  REQUEST_MIC: `POPO需要访问麦克风的权限`,
  REQUEST_CAMERA: `POPO需要访问摄像头的权限`,
  REQUEST_MIC_CONTENT: `请在【系统偏好设置】-【安全性和隐私】，为POPO启动麦克风权限`,
  REQUEST_CAMERA_CONTENT: `请在【系统偏好设置】-【安全性和隐私】，为POPO启动摄像头权限`,
  CONFIRM: `确定`,
  INVITE_YOU_TO_THE_MEETING: `邀请你加入会议;`,
  CONFERENCE_THEME: `会议主题`,
  CONFERENCE_NUMBER: `会议号`,
  CONFERENCE_LINKS: `会议链接`,
  ALLOW_MEMBERS_TO_JOIN_THROUGH_WEB_BROWSER: `允许成员通过Web浏览器入会`,
  THE_MEETING_INFORMATION_HAS_BEEN_COPIED_TO_THE_CLIPBOARD: `会议信息已复制到剪切板`,
  SHARE_TO_CONVERSATION: `分享至会话`,
  COPY_MEETING_LINK: `复制会议链接`,
  SHARE_INVITATION_CARD: `分享邀请卡`,
  STOP_SHARE: `{name}已停止共享屏幕`,
  START_TIME: `开始时间`,
  SPEAKING: `正在说话：`,
  HOST: `主持人`,
  CAMERA: `摄像头`,
  MICROPHONE: `麦克风`,
  SPEAKER: `扬声器`,
  TURNED_OFF_MIC_BY_HOST: `主持人已将您静音`,
  TURNED_OFF_CAMERA_BY_HOST: `主持人已关闭您的摄像头`,
  MEETING_ENDING: `会议已结束`,
  MEETING_NOT_EXIST: `会议不存在`,
  LEAVE_MEETING: `离开会议`,
  KICK_OUT: `主持人已将您移除会议`,
  CAMERA_ON: `打开视频`,
  CAMERA_OFF: `关闭视频`,
  MIC_ON: `取消静音`,
  MIC_OFF: `静音`,
  SETTINGS: `设置`,
  THE_MODERATOR_HAS_CLOSED_THE_CHAT_IN_THE_MEETING: `主持人已关闭会议内聊天`,
  THE_HOST_HAS_TURNED_OFF_THE_MEETING_CHAT_FUNCTION: `主持人已关闭该会议聊天功能`,
  THE_HOST_HAS_STARTED_CHATTING_IN_THE_MEETING: `主持人已开启会议内聊天`,
  CHAT: `聊天`,
  NEW_NEWS: `新消息`,
  NO_MORE_NEWS: `没有更多消息了`,
  LOADING: `加载中`,
  SEND_A_MESSAGE_TO_EVERYONE: `向所有人发送消息...`,
  SEND: `发送`,
  LINE_FEED: `换行`,
  ME: `我`,
  SWITCH_MIC_TIPS: `仅在开启麦克风时可切换设备`,
  AUDIOVIDEO_CONFERENCE: `音视频会议`,
  MEMBER_MANAGEMENT: `参会人`,
  CLOSE: `关闭`,
  MEMBER: `参会人`,
  HOST_OPEN_MIC: `主持人请求打开你的麦克风`,
  HOST_OPEN_CAMERA: `主持人请求打开你的摄像头`,
  IOS_UNDER_13: `暂不支持 iOS 13 及以下系统版本，请升级后重试。`,
  NOT_SHARE_SCREEN: `无法共享屏幕`,
  SYSTEM_PREFERENCES_RMISSION: `需前往系统偏好设置为当前浏览器启用屏幕录制权限才能共享屏幕`,
  ANYONE_SHARING_THE_SCREEN: `{name}正在共享屏幕`,
  ARE_YOU_SURE_YOU_WANT_TO_STOP_SCREEN_SHARING: `确定要停止屏幕共享吗？`,
  YOU_ARE_SHARING_THE_SCREEN: `你正在共享屏幕`,
  STOP_SHARING: `停止共享`,
  SHARE_SCREEN: `屏幕共享`,
  OPEN_WHITEBOARD: `打开白板`,
  STOP_WHITEBOARD: `关闭白板`,
  WHITEBOARD_OPENED: `开启了互动白板`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_SCREEN_SHARING: `当前共享状态下暂不支持共享其他内容`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_DUPLICATED: `互动白板已开启，无法重复开启`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_WHITEBOARD: `当前白板状态下暂不支持共享其他内容`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_DUPLICATED: `其他人正在屏幕共享`,
  EXPORT_BEFORE_TERMINATE_WHITEBOARD: '结束白板前是否需要导出当前内容？',
  SNAPSHOT: '快照',
  EXPORT_TO_CLOUD_SPACE: '导出到云空间',
  EXPORT_TO_LOCAL: `导出到本地`,
  EXPORTED_TO_CLOUD_SPACE: '已导出至我的空间',
  TERMINATE: '结束',
  EXPORT: '导出',
  DONT_EXPORT: '不导出',
  PERSPECTIVE_SYNCHRONIZATION: `视角同步`,
  CURRENT_PARTICIPANTS_WILL_FOLLOW_YOUR_PERSPECTIVE: `当前参会人将跟随你的视角`,
  THE_PERSPECTIVE_SYNCHRONIZATION_HAS_BEEN_TURNED_ON: `已开启视角同步，当前参会人将跟随你的视角`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_PERMISSION: `当前会议仅主持人可打开白板`,
  PERSPECTIVE_SYNCING: `视角同步中`,
  PERSPECTIVE_OF: `的视角`,
  YOU_ARE_CURRENTLY_IN_PERSPECTIVE_SYNCHRONIZATION: `你当前处于视角同步中`,
  YOU_WILL_FOLLOW: `你将跟随`,
  PERSPECTIVE_SYNCHRONIZATION_IS_TURNED_ON: `开启了视角同步`,
  TOOLBAR_SELECT: `选择`,
  TOOLBAR_BRUSH: `画笔`,
  TOOLBAR_SHAPE: `形状`,
  TOOLBAR_ERASER: `橡皮`,
  TOOLBAR_LASER: `激光笔`,
  TOOLBAR_TEXT: `文本`,
  ZOOM_TO_100: `缩放至100%`,
  ZOOM_IN: `放大`,
  ZOOM_OUT: `缩小`,
  SCALE_TO_PROPER_SIZE: `缩放到适当大小`,
  MOVE_CANVAS: `移动画布`,
  STOP: `停止`,
  UNABLE_OPEN_VIDEO_ON_SCREEN: `正在共享屏幕不可开启视频。`,
  INPUT_OLD_CLOSE_CARAME: `当前会议中包含旧版本的用户，为保证会议体验，共享时暂时不可开启摄像头`,
  DIVIECE_DISABLE_MAC: `请至系统偏好设置 >  安全性和隐私，为浏览器开启设备权限`,
  DIVIECE_DISABLE_IOS: `请至设置 >  Safari浏览器 > 网站设置，为浏览器开启设备权限，并刷新页面重试`,
  DIVIECE_DISABLE_ANDROID: `请至系统设置，为浏览器开启设备权限，并刷新页面重试`,
  DIVIECE_DISABLE_WINDOWS: `请至浏览器设置 >  隐私设置和安全性 > 网站设置，开启设备权限，并刷新页面重试`,
  DIVIECE_DISABLE_TITLE: `打开设备失败`,
  BROWER_DISABLE: `暂不支持当前浏览器，请复制会议地址使用 {name} 浏览器打开`,
  COPY_URL: `复制会议地址`,
  COPY_SUCCESS: `复制成功`,
  BROWSER_INCOMPATIBLE: `当前使用的浏览器存在兼容问题`,
  BROWSER_VERSION_UP: `请使用 {baseVersion}版本及以上的 {browser}浏览器`,
  DOWNLOAD_BROWSER: `下载浏览器`,
  MIC_INCOMPATIBLE: `POPO 会议请求授予音频设备播放权限`,
  MIC_CLICK_ABLE: `浏览器页面限制，请点击授予权限。`,
  DISABLE_TOKEN: `登录已过期，请重新输入会议地址登录`,
  WHAT_PROBLEM: `遇到什么问题？`,
  PBDYP: `请简单描述您的问题`,
  OTHER: `其他`,
  FEEDBACK1: `无法加入会议`,
  FEEDBACK2: `无法开麦`,
  FEEDBACK3: `无法开启摄像头`,
  FEEDBACK4: `音频问题`,
  FEEDBACK5: `视频问题`,
  FEEDBACK6: `屏幕共享问题`,
  PROMPT: `提示`,
  FEEDBACK: `反馈`,
  CHANGENET: `当前网络异常，请更换其他网络连接并刷新重试`,
  CHECK_DEVICES_FIRST: '加入会议前请先进行设备检测',
  CHECK_DEVICES: '设备检测',
  NO_DATA: '暂无数据',
  MICROPHONE_CHECKER_TIPS: '请说一句话然后等一会，你听到刚才的回放了吗？',
  SPEAKER_CHECKER_TIPS: '你听到铃声了吗？',
  CHOOSE_MICROPHONE: '选择麦克风',
  CHOOSE_SPEAKER: '选择扬声器',
  OUTPUT_LEVEL: '输出级别',
  INPUT_LEVEL: '输入级别',
  YES: '是',
  NO_SOUND_NEXT_SPEAKER: '没有，测试下一扬声器',
  NO_VOICE_NEXT_MICROPHONE: '没有，测试下一麦克风',
  TESTING_NTH_WITH_TOTAL_NUM: '正在测试第 {number} 项 (共{total}项)',
  NEXT_STEP: '下一步',
  SPEAKER_ERR: '你的扬声器未工作正常',
  SPEAKER_MIC_ERR: '你的扬声器和麦克风未正常工作',
  DEVICE_NOT_WORK: '设备未正常工作',
  SPEAKER_MIC_WORKED: '扬声器与麦克风工作正常',
  CHANGE_AUDIO_RECHECK: '请更换至可用设备并重新调试',
  END_CHECK: '结束测试',
  RECHECK: '重新测试',
  COMPLETE: '完成',
  JOIN_MEETING: '加入会议',
  RECORDING: '正在录音',
  BROADCASTING: '正在播放',
  MICROPHONE_RECORDING_TIPS: '正在录音，请说一句话然后等一会',
  MICROPHONE_BROADCASTING_TIPS: '正在播放，你听到刚才的回放了吗',
  APPLICATION: `应用`,
  WHITEBOARD: `互动白板`,
  EDITOR: `代码编辑器`,
  OPENING_INTERACTIVE_WHITEBOARD: `正在打开互动白板`,
  OPENING_CODE_EDITOR: `正在打开代码编辑器`,
  EDITOR_CLOSED: `关闭了代码编辑器`,
  OPEN_EDITOR: `开启了代码编辑器`,
  SWITCHED_LANG: `已将语言环境切换为`,
  SCREEN_SHARED: `当前正在共享屏幕`,
  OTHER_SHAREDING_SCREEN: `当前其他人正在共享屏幕`,
  FAILED_TO_OPEN_CODE_EDITOR_BECAUSE_OF_SCREEN_SHARING: `共享状态下暂不支持打开代码编辑器`,
  FAILED_TO_OPEN_CODE_EDITOR_BECAUSE_OF_WHITEBOARD: `已开启白板暂不能打开代码编辑器`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_CODEEDITOR: `当前代码编辑器状态下暂不支持共享其他内容`,
  REFRESH: `刷新`,
  CAMERA_IS_OFF: `摄像头已关闭`,
  MEETING_TIME: `会议时间`,
  AGREE: `同意`,
  I_AGREE_TO_THE: `我已阅读并同意`,
  PRIVACY_POLICY: `隐私政策`,
  PLEASE_AGREE_TO: `请先同意`,
  NETWORK_FAILED_REFRESH: `网络连接失败，请检查网络并刷新重试`,
  SUPPORT_BY_QA_ZEN: `由QA-Zen提供技术支持`,
  CLOSE_COLEDITOR: '确定要关闭代码编辑器吗？',
  WILL_CLOSE_FOR_ALL_MEETING_ATTENDEES: '将会为所有参会人员关闭代码编辑器页面',
  ACTIVATING_TRANSCRIPTION: `正在开启转录`,
  TRANSCRIPTION_ACTIVATION_FAILED: `转录开启失败`,
  TRY_AGAIN: `重试`,
  TRANSCRIPTION_LANGUAGE: `识别源语言 `,
  TRANSLATE_INTO: `目标翻译语言`,
  TRANSCRIPTION_LANGUAGE_WILL_BE_AUTOMATICALLY_DETECTED: `开启翻译后将自动识别源语言`,
  STOPPED_TRANSCRIPTION: `主持人已停止转录 `,
  REQUEST_TO_ACTIVATE_TRANSCRIPTION: `申请开启转录 `,
  MEETING_TRANSCRIPTION: `会议转录`,
  NO_TRANSLATE: `不翻译`,
  TRANSCRIPTION_IS_ENABLED: `{meetingName} 已开启转录`,
  TRANSCRIPTION_IS_ENABLED1: `已开启转录`,
  TRANSCRIPTION_ENABLE_FAILED: `开启转录失败`,
  AUTOMATICALLY_RECOGNIZED: `自动识别`,
  RECORD: `录制`,
  REQUEST_SENT: `申请已发送`,
  REQUEST_RECORDING2: `向主持人发送申请，开启本场会议录制`,
  MEETING_RECORDING_ENABLED: `主持人已开启会议录制`,
  REQUEST_RECORDING: `向主持人申请录制？`,
  REJECT_RECORDING: `主持人已拒绝开启录制`,
  RECORDING2: `录制中`,
  RECORDING_PAUSED: `录制已暂停`,
  RECORDING_RESUMED: `录制已继续`,
  RECORDING_STOPPED: `录制已停止`,
  RECORDING_CANNOT_BE_STARTED: `暂时无法开启录制`,
  MORE: `更多`,
  COLLAPSE2: `收起`,
  DEVICE_IS_ABNORMAL: `设备异常，请检查设备并刷新重试`,
  INTERPRETATION_ENABLED: '主持人已开启同声传译',
  INTERPRETATION_DISABLED: '主持人已关闭同声传译',
  INTERPRETATION: '同声传译',
  HOST_UPDATED_YOUR_LANGUAGE_PAIR: '主持人已更新传译服务语言',
  AUDIENCE_CHANNEL: '收听频道',
  MAIN_CHANNEL: '主频道（会场原声）',
  POWERED_BY: '由网易云信和互娱AI提供技术支持',
  INTERVIEW_CAMERA_TIPS: '默认关闭摄像头，请做好准备后开启。为保证面试效果，过程中请保持摄像头开启。',
  ENTER_YOUR_NAME: '请输入姓名',
  INTERPRETERS: '译员',
  UNMUTE_ORIGINAL_CHANNEL: '主频道解除静音',
  RECEIVE_MAIN_CHANNEL: '同时收听主频道',
  MAIN_CHANNEL_VOICE: '主频道音量',
  MAIN_CHANNEL_VOICE_H5: '主频道',
  VOLUME: '音量',
  NOTIFY_PARTICIPANTS: '提醒其他参会人入会',
  LOGIN: '登录',
  membershipTypeSelection: '请选择入会身份',
  oscar: '使用Oscar登录',
  supportedAccountTypes: '支持工作室和OC邮箱账号',
  usingOpenIDLogin: '使用OpenID登录',
  supportsCorpEmailAccount: '支持Corp邮箱账号',
  guestLogin: '游客身份登录',
  joinAsGuestEnabled: '以游客身份入会',
  youAreTheHost: '本场会议中你为主持人',
  useNetEasePOPOClient: '请使用网易POPO客户端入会',
  openNetEasePOPOClient: '打开网易POPO客户端',
  downLoadPopo: '下载网易POPO',
  noMeetingAccess: '暂无参加会议权限',
  contactMeetingOrganizer: '请联系会议组织者{name}',
  disableSubtitles: '关闭字幕',
  enableSubtitles: '开启字幕',
  isEnablingSubtitles: '正在开启字幕...',
  Chinese: '简体中文',
  automaticRecognition: '自动识别(Beta)',
  subtitleRegSourceLang: '识别源语言',
  targetTrasLang: '目标翻译语言',
  switchAccounts: '切换账户',
  guest: '游客',
  big: '大',
  small: '小',
  fontSize: '字号',
  subtitleStatus: '字幕生成失败',
  transcribePaused: '转录已停止',
  transcribe: '转录',
  requestTranscriptionToHost: '向主持人申请转录？',
  barrage: '字幕',
  translate: '翻译',
  openTranscribe: '主持人已开启会议转录',
  offTranscribe: '主持人已停止转录',
  canNotOpenTranscribe: '暂时无法开启转录',
  newSubtitle: '新字幕',
  refuseToEnableTranscription: '拒绝开启转录',
  realTimeTranscriptionTip: '实时转录会议记录，会议结束后可在学习鸡平台查看转录文档',
  noPermission: '仅主持人可开启白板',
  reaction: '回应',
  handup: '举手',
  handoff: '取消举手',
  xHandsRaising: '{count}人正在举手',
  meetingReactionsAreDisabled: '本场会议中，主持人已关闭表情回应',
  emojiSent: '表情已发送',
  cancelledYourRaiseOfHand: '主持人已取消你的举手',
  firstLoading: '首次加载，请稍候',
  emoLoadedFail: '加载失败',
  reload: '重试',
  exportTo: '导出到{name}',
  audioCaptureFailed: '音频采集异常，请刷新页面或检查麦克风',
  grid: '宫格',
  lecture: '演讲',
  inTranscript: '转录中',
  meetingInformation: '会议信息',
  onShareing: '正在共享',
  devicAbnormality: '当前设备异常',
  enableScreenSharing: '开启屏幕共享',
  inShareing: '共享',
  openSetting: '打开设置',
  member: '成员',
  enableAllFocusedTa: '已开启全员看TA',
  enableChangeFocusedTa: '已切换全员看TA',
  disabledAllFocusedTa: '已取消全员看TA',
  codeEditorFocused: '代码编辑器/专注模式进程中，请关闭后重试',
  spotLighted: '全员看TA',
  temporarilyUnmute: '暂时解除静音',
  turnOnTheMicrophone: '开启麦克风。按住空格暂时开启麦克风',
  turnOffTheMicrophone: '关闭麦克风',
  isTalking: '正在讲话：',
  unableToSwitchLayout: '无法切换布局',
  inFocusedMode: '当前处于专注模式',
  transcriptionHelpTip: '实时转录会议记录，会议结束后可在云空间内查看转录文档。',
  interpretationBtnTooltip: '为本场会议开启同声传译并指派同传译员',
  availableMicrophoneIsNotDetected: '未检测到可用麦克风',
  unableToDetectCamera: '未检测到可用摄像头',
  internetConnectionTest: '网络质量检测',
  password: '会议密码',
  userName: '入会人姓名',
  enterPassword: '请输入密码',
  errorPassword: '密码错误',
  meetingNeedPassword: '会议需要密码',
  mouse: '鼠标',
  laser: '激光笔',
  select: '选择',
  pen: '画笔',
  graph: '图形',
  text: '文本',
  color: '颜色',
  eraser: '橡皮擦',
  undo: '撤销',
  redo: '重做',
  clear: '清除所有',
  save: '保存',
  close: '关闭',
  setSharertoAnnotate: '当前会议已设置共享人可标注',
  setSharertoAnnotateAll: '当前会议所有人可标注',
  openAnnotate: `{name}开启了标注`,
  marker: '马克笔',
  lineWidth: '画笔粗细',
  line: '直线',
  oval: '椭圆形',
  arrow: '箭头',
  rectangle: '矩形',
  replaceShare: '确认共享将替换当前共享画面',
  confirm: '确认',
  penInk: '钢笔',
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_CODE_EDITOR: '已开启代码编辑器，不支持同时开启白板',
  popoVersionOld: '共享人POPO版本较低，不支持批注',
  disableOpenAnnotate: '当前会议已设置仅共享人可标注',
  unableChangeColor: '暂不支持设置文字颜色',
  coHost: '联席主持人',
  becomeCoHost: '{name} 成为联席主持人',
  revokeHostPrivileges: '{name} 被取消联席主持人权限',
  openCodeFail: '打开代码编辑器失败',
  reOpen: '重新打开',
  videoCaptureFailed: '视频采集异常，请刷新页面或检查麦克风',
  fullScreenView: '应用内全屏观看',
  reduceScreenSize: '缩小画面',
  STOPPED_AI_MINUTES: '主持人已停止AI纪要',
  STOPPED_AI_MINUTES_OTHER: '主持人已停止AI纪要，会议原文暂停显示',
}
